<template>
    <div class="flight-details-itinerary">
        <div>
            <div class="flight-details-itinerary-item" v-for="itinerary in flight.itineraries">
                <div class="flight-details-time">
                    <div class="flight-details-time-range">
                        <div class="flight-details-time-range-text">{{ itinerary.departure.time }}</div>
                        <div class="flight-details-time-range-arrow">
                            <i class="fa fa-arrow-right"></i>
                        </div>
                        <div class="flight-details-time-range-text">{{ itinerary.arrival.time }}</div>
                    </div>
                    <div class="flight-details-time-interval">{{ itinerary.interval }}</div>
                </div>
                <div class="flight-details-info">
                    <div class="flight-details-info-item" v-if="itinerary.departure.location">{{ getAirportName(itinerary.departure.location) }} to {{ getAirportName(itinerary.arrival.location) }}</div>
                    <div class="flight-details-info-item" v-if="itinerary.departure.location">{{ getAirportCityName(itinerary.departure.location) }} ({{ itinerary.departure.location }}) to {{ getAirportCityName(itinerary.arrival.location) }} ({{ itinerary.arrival.location }})</div>
                    <div class="flight-details-info-item" v-if="itinerary.segments[0].cabinName && itinerary.segments[0].cabin">{{ itinerary.segments[0].cabinName }} ({{ itinerary.segments[0].cabin }})</div>
                    <div class="flight-details-info-item" v-if="itinerary.segments[0].carrier">{{ getAirlineName(itinerary.segments[0].carrier) }} {{ itinerary.segments[0].flightNumber }}</div>
                    <div class="flight-details-info-item" v-if="isCustom">Arrival Date: {{ itinerary.arrival.time }} {{ itinerary.arrival.date }}</div>
                </div>
                <div class="flight-details-layover" v-if="itinerary.layover">
                    <div class="flight-details-layover-item" v-if="layover.time" v-for="layover in itinerary.layover.locations">
                        <div class="flight-details-layover-item-clock">
                            <i class="fa fa-clock-o"></i>
                        </div>
                        <div class="flight-details-layover-item-time">{{ layover.time }}</div>
                        <div class="flight-details-layover-item-location" v-if="layover.location">{{ getAirportCityName(layover.location) }} ({{ layover.location }})</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flight-details-itinerary-summary">
            <div class="flight-details-info-head">Price Summary:</div>
            <div class="flight-details-info-item" v-if="travellers" v-for="traveller in travellers">{{ traveller.totalPriceAmount | price }} per {{ traveller.postfix }}</div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {
        AIRLINE_GETTER,
        AIRPORT_CITY_GETTER,
        AIRPORT_NAME_GETTER,
        FLIGHTS_NAMESPACE,
        IS_CUSTOM_GETTER
    } from '../store/modules/flights';
    import priceMixin from '../mixins/price';
    import {
        TRAVELLER_ADULT_CODE,
        TRAVELLER_ADULT_LABEL,
        TRAVELLER_CHILD_CODE_ADDITIONAL,
        TRAVELLER_CHILD_LABEL,
        TRAVELLER_INFANT_CODE,
        TRAVELLER_INFANT_LABEL,
        TRAVELLER_TRAVELER_LABEL
    } from '../../services/configService';

    export default {
        name: 'flights-details',
        mixins: [
            priceMixin
        ],
        props: {
            flight: Object
        },
        computed: {
            /**
             * Getters from vuex storage
             */
            ...mapGetters(FLIGHTS_NAMESPACE, [
                AIRLINE_GETTER,
                AIRPORT_CITY_GETTER,
                AIRPORT_NAME_GETTER,
                IS_CUSTOM_GETTER
            ]),
            /**
             * Is equal price
             *
             * @return {boolean}
             */
            isEqualPrices() {
                const prices = this.flight.travellers.map(item => item.totalPriceAmount);
                return prices.every(price => price === prices[0]);
            },
            /**
             * Get travelers
             *
             * @return {Array}
             */
            travellers() {
                if (this.isEqualPrices) {
                    return [{
                        postfix: TRAVELLER_TRAVELER_LABEL,
                        totalPriceAmount: this.flight.travellers[0].totalPriceAmount
                    }];
                }
                return this.flight.travellers.map(traveller => {
                    switch (traveller.type) {
                        case TRAVELLER_ADULT_CODE:
                            traveller.postfix = TRAVELLER_ADULT_LABEL;
                            break;
                        case TRAVELLER_CHILD_CODE_ADDITIONAL:
                            traveller.postfix = TRAVELLER_CHILD_LABEL;
                            break;
                        case TRAVELLER_INFANT_CODE:
                            traveller.postfix = TRAVELLER_INFANT_LABEL;
                            break;
                    }
                    return traveller;
                });
            }
        }
    };
</script>

<style lang="scss">
    .flight-details {

        &-itinerary {
            width: 380px;

            &-item {
                padding: 30px;

                &:not(:last-child) {
                    border-bottom: 1px solid $border-color;
                }
            }

            &-summary {
                padding: 0 30px 30px;
            }
        }

        @import '../../../../scss/frontend/components/flight-details/time';
        @import '../../../../scss/frontend/components/flight-details/info';
        @import '../../../../scss/frontend/components/flight-details/layover';
    }
</style>
